import LazyLoad from 'vanilla-lazyload';

const lazyLoadConfig = { elements_selector: '[data-lazy]' };

if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad(lazyLoadConfig);
}
